import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
}));

const ValueProposal = ({ values, pictoD }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Grid
      item
      container
      direction="row"
      justify="space-between"
      className={classes.root}
    >
      <Grid item xs={4}>
        <div style={{ width: !matches ? "80%" : "50%" }}>
          <img src={pictoD} alt="picto" width="50%" />
        </div>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="h6" className={classes.blueBoxTitle}>
          {values.title}
        </Typography>
        <Typography variant="body1" className={classes.blueBoxText}>
          {values.content}
        </Typography>
      </Grid>
    </Grid>
  );
};

ValueProposal.propTypes = {
  values: PropTypes.object.isRequired,
  pictoD: PropTypes.string.isRequired,
};

export default ValueProposal;
